import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { Agency } from '@app/models';
import { ProgressStatus } from '@app/pcs/models';
import { toLower } from 'ramda';

@Component({
  selector: 'pcs-traffic-light',
  templateUrl: './traffic-light.component.html',
  styleUrls: ['./traffic-light.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrafficLightComponent implements OnInit, OnChanges {
  @Input() progressStatus: ProgressStatus;
  @Input() agency: Agency;
  @Input() icon: string;
  @Input() leading = false;
  @Input() disabled = true;
  @Input() extended = false;

  @HostBinding('attr.title')
  get agencyName() {
    return this.agency ? this.agency.name : '';
  }

  constructor(private element: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit(): void {
    this.renderer.addClass(this.element.nativeElement, this.getProgressStatusClass());

    if (this.extended) {
      this.renderer.addClass(this.element.nativeElement, 'extended');
    }
  }

  ngOnChanges({disabled: disabledChange}: SimpleChanges): void {
    if (disabledChange && disabledChange.currentValue !== disabledChange.previousValue) {
      this.toggleDisabled();
    }
  }

  getIcon() {
    return this.leading ? 'star' : this.icon;
  }

  hasIcon() {
    return this.icon || this.leading;
  }

  getProgressStatusClass() {
    const progressStatusId = this.showProvidedProgressStatus() ? this.progressStatus.id : 'F';
    return `progress-status-${toLower(progressStatusId)}`;
  }

  showProvidedProgressStatus() {
    return this.agency ? this.agency.pathfinderMember && !this.agency.unknownAgency : true;
  }

  private toggleDisabled() {
    if (this.disabled) {
      this.renderer.addClass(this.element.nativeElement, 'disabled');
    } else {
      this.renderer.removeClass(this.element.nativeElement, 'disabled');
    }
  }

}
